export default "__VITE_ASSET__DgTgNjwz__"